<template>
  <div class="relative">
    <button @click="toggleDropdown" class="flex items-center p-2 rounded-lg text-text-secondary hover:text-text-primary hover:bg-bg-accent dark:hover:bg-gray-700 transition-colors duration-200 focus:outline-none">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M7 2a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L9 5.414V13a1 1 0 11-2 0V5.414L5.707 6.707a1 1 0 01-1.414-1.414l3-3A1 1 0 017 2zM13 7a1 1 0 011 1v5.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 111.414-1.414L13 13.586V8a1 1 0 011-1z" clip-rule="evenodd" />
        <path d="M5.75 3a.75.75 0 00-.75.75v12.5c0 .414.336.75.75.75h8.5a.75.75 0 00.75-.75V3.75a.75.75 0 00-.75-.75h-8.5zM6.5 4.5h7V16h-7V4.5z" />
      </svg>
      <span class="ml-1 uppercase text-sm font-medium">{{ currentLanguage }}</span>
    </button>

    <transition name="fade">
      <div v-if="isOpen" class="absolute right-0 mt-2 w-32 bg-bg-primary dark:bg-gray-700 rounded-md shadow-lg overflow-hidden z-20 border border-border-primary dark:border-gray-600">
        <ul>
          <li>
            <a href="#" @click.prevent="switchLanguage('de')" class="block px-4 py-2 text-sm text-text-primary dark:text-gray-200 hover:bg-bg-accent dark:hover:bg-gray-600">
              Deutsch (DE)
            </a>
          </li>
          <li>
            <a href="#" @click.prevent="switchLanguage('en')" class="block px-4 py-2 text-sm text-text-primary dark:text-gray-200 hover:bg-bg-accent dark:hover:bg-gray-600">
              English (EN)
            </a>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n(); // Zugriff auf die globale locale Instanz
const isOpen = ref(false);

const currentLanguage = computed(() => locale.value);

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const switchLanguage = (lang) => {
  locale.value = lang; // Ändere die globale Sprache
  localStorage.setItem('userLanguage', lang); // Speichere die Auswahl
  isOpen.value = false; // Schließe das Dropdown
};

// Schließen, wenn außerhalb geklickt wird (optional, aber gute UX)
// Dies erfordert eine kleine Direktive oder komplexere Logik,
// der Einfachheit halber hier weggelassen, kann aber hinzugefügt werden.
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style> 